import * as React from "react"
import classNames from "classnames"
import { twMerge } from "tailwind-merge"
import { LoadingSpinner } from "@oysterhr/ui"

const NEW_TAB_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
}
interface LinkButtonProps extends React.HTMLProps<HTMLAnchorElement> {
  loading?: boolean
  testid?: string
  emphasized?: boolean
  newTab?: boolean
  dataAnalyticsName?: string
}

const LinkButton = ({
  emphasized = false,
  loading,
  href,
  className,
  testid,
  children,
  newTab,
  onClick,
  dataAnalyticsName,
}: LinkButtonProps) => {
  const cn = twMerge(
    classNames("md:ml-4 border-gray-400 cursor-pointer", className, {
      "text-primary-base underline decoration-primary-base font-medium": emphasized,
      "text-gray-400": !emphasized,
    }),
  )

  return (
    <a
      {...(newTab ? NEW_TAB_PROPS : {})}
      className={cn}
      href={href}
      onClick={e => {
        if (loading) {
          e.preventDefault()
        }
        onClick?.(e)
      }}
      data-testid={testid}
      data-analytics-name={dataAnalyticsName}
    >
      {loading ? <LoadingSpinner /> : children}
    </a>
  )
}

export default LinkButton
